"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const uuid_1 = require("uuid");
const BaseBuilder_1 = __importDefault(require("./BaseBuilder"));
const SectionBuilder_1 = __importDefault(require("./SectionBuilder"));
class BlueprintBuilder extends BaseBuilder_1.default {
    seedProviders;
    blueprint;
    constructor(seedProviders) {
        super();
        this.seedProviders = seedProviders;
        this.blueprint = {
            sectionBlueprints: [],
            sectionGroupBlueprints: {
                insuredPeople: {
                    id: (0, uuid_1.v4)(),
                    partName: 'insuredPeople',
                    title: { en: 'SectionGroup Title', fr: 'Titre du groupe de sections' },
                    repeatable: { minRepeatable: 1, maxRepeatable: 6, repeatableAnswerNodeId: 'insured-people' },
                },
                contract: { id: (0, uuid_1.v4)(), partName: 'contract' },
            },
        };
    }
    withSectionGroups(sectionGroupBuilders) {
        if (!sectionGroupBuilders) {
            return this;
        }
        delete this.blueprint.sectionGroupBlueprints.contract;
        delete this.blueprint.sectionGroupBlueprints.insuredPeople;
        if (Array.isArray(sectionGroupBuilders)) {
            for (const sectionGroupBuilder of sectionGroupBuilders) {
                const key = sectionGroupBuilder.getSectionGroupKey();
                if (key) {
                    const sectionGroup = sectionGroupBuilder.build();
                    this.blueprint.sectionGroupBlueprints[key] = sectionGroup;
                }
            }
        }
        else {
            const key = sectionGroupBuilders.getSectionGroupKey();
            if (key) {
                const sectionGroup = sectionGroupBuilders.build();
                this.blueprint.sectionGroupBlueprints[key] = sectionGroup;
            }
        }
        return this.clone();
    }
    withSections(sectionBuilders) {
        if (!sectionBuilders) {
            return this;
        }
        if (Array.isArray(sectionBuilders)) {
            const builtSections = [];
            for (const sectionBuilder of sectionBuilders) {
                builtSections.push(sectionBuilder.build());
            }
            this.blueprint.sectionBlueprints = this.blueprint.sectionBlueprints.concat(builtSections);
        }
        else {
            this.blueprint.sectionBlueprints.push(sectionBuilders.build());
        }
        return this.clone();
    }
    withSubsections(subsectionBuilders) {
        this.blueprint.sectionBlueprints.push(this.childBuilder().withSubsections(subsectionBuilders).build());
        return this.clone();
    }
    withFieldGroups(fieldGroupBuilders) {
        this.blueprint.sectionBlueprints.push(this.childBuilder().withFieldGroups(fieldGroupBuilders).build());
        return this.clone();
    }
    withFields(fieldBuilders) {
        this.blueprint.sectionBlueprints.push(this.childBuilder().withFields(fieldBuilders).build());
        return this.clone();
    }
    build() {
        return lodash_1.default.cloneDeep(this.blueprint);
    }
    childBuilder() {
        return new SectionBuilder_1.default(this.seedProviders);
    }
}
exports.default = BlueprintBuilder;
